import styled from "styled-components";

export const LotterDisplayContent = styled.div`
  width: 100%;
`;

export const TvShowcaseWrapper = styled.div`
  position: relative;
  max-width: 900px;
  margin: 0 auto 50px auto;
  display: flex;
  justify-content: center;
  align-items: center;

  .tv-ambient-glow {
    position: absolute;
    width: 80%;
    height: 70%;
    background: radial-gradient(circle, rgba(40, 6, 249, 0.22) 0%, rgba(40, 6, 249, 0) 70%);
    filter: blur(40px);
    z-index: 1;
    pointer-events: none;
  }

  .img {
    position: relative;
    z-index: 2;
    width: 100%;
    display: flex;
    justify-content: center;

    img {
      max-width: 100%;
      height: auto;
      object-fit: contain;
      filter: drop-shadow(0 20px 40px rgba(12, 21, 56, 0.16));
      transition: transform 0.4s ease;

      &:hover {
        transform: scale(1.02);
      }
    }
  }
`;

export const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-top: 20px;

  @media screen and (max-width: 960px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`;

export const FeatureBox = styled.div`
  background: #f8fafd;
  border: 1.5px solid #e5ebf8;
  border-radius: 16px;
  padding: 24px 20px;
  transition: all 0.3s ease;

  &:hover {
    background: #ffffff;
    border-color: #2806f9;
    transform: translateY(-4px);
    box-shadow: 0 12px 28px rgba(40, 6, 249, 0.1);
  }

  .icon-wrap {
    width: 44px;
    height: 44px;
    background: rgba(40, 6, 249, 0.08);
    color: #2806f9;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    margin-bottom: 16px;
    transition: all 0.25s ease;
  }

  &:hover .icon-wrap {
    background: #2806f9;
    color: #ffffff;
  }

  h4 {
    font-size: 16px;
    font-weight: 700;
    color: #0c1538;
    margin-bottom: 8px;
    line-height: 1.3;
  }

  p {
    font-size: 13.5px;
    line-height: 1.5;
    color: #586380;
    margin: 0;
  }
`;
